import { SmsLinkCallback } from "./pages/authentication/SmsLinkCallback";
import { EmailLinkCallback } from "./pages/authentication/EmailLinkCallback";
import { AuthProfilePrompt } from "./pages/authentication/components/AuthProfilePrompt";
import React, { Suspense } from "react";
import { ChakraProvider, Spinner, Center } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./apollo/client";
import SiteMap from "./pages/SiteMap";
import { ScrollToTop } from "./components/ScrollToTop";

// ============ ONE GROUP CLIENT PAGES ============
// Public website pages for onegroupaustralasia.com.au (80+ pages)
// All pages are in /pages/client_pages/ to keep separate from backend modules

// Main Pages (11 pages)
import OneGroupHome from "./pages/client_pages/main/Home";
import About from "./pages/client_pages/main/About";
import Solutions from "./pages/client_pages/main/Solutions";
import SolutionsSolarProperty from "./pages/client_pages/main/SolutionsSolarProperty";
import SolutionsFinanceSolar from "./pages/client_pages/main/SolutionsFinanceSolar";
import SolutionsWealthBuilding from "./pages/client_pages/main/SolutionsWealthBuilding";
import SolutionsFirstHomeSolar from "./pages/client_pages/main/SolutionsFirstHomeSolar";
import SolutionsInvestmentSolarBattery from "./pages/client_pages/main/SolutionsInvestmentSolarBattery";
import SolutionsRefinanceSolarBattery from "./pages/client_pages/main/SolutionsRefinanceSolarBattery";
import ContactPage from "./pages/client_pages/main/Contact";
import SuccessStories from "./pages/client_pages/main/SuccessStories";

// Solar Division Pages (17 pages)
import SolarHome from "./pages/client_pages/solar/SolarHome";
import SolarServices from "./pages/client_pages/solar/SolarServices";
import SolarServicesResidential from "./pages/client_pages/solar/SolarServicesResidential";
import SolarServicesCommercial from "./pages/client_pages/solar/SolarServicesCommercial";
import SolarServicesBattery from "./pages/client_pages/solar/SolarServicesBattery";
import SolarServicesMonitoring from "./pages/client_pages/solar/SolarServicesMonitoring";
import SolarServicesInvestmentProperty from "./pages/client_pages/solar/SolarServicesInvestmentProperty";
import SolarProcess from "./pages/client_pages/solar/SolarProcess";
import SolarResources from "./pages/client_pages/solar/SolarResources";
import SolarResourcesTechnology from "./pages/client_pages/solar/SolarResourcesTechnology";
import SolarResourcesIncentives from "./pages/client_pages/solar/SolarResourcesIncentives";
import SolarResourcesMaintenance from "./pages/client_pages/solar/SolarResourcesMaintenance";
import SolarResourcesComparisons from "./pages/client_pages/solar/SolarResourcesComparisons";
import SolarResourcesBatteryGuide from "./pages/client_pages/solar/SolarResourcesBatteryGuide";
import SolarFAQ from "./pages/client_pages/solar/SolarFAQ";
import SolarCalculator from "./pages/client_pages/solar/SolarCalculator";
import SolarQuote from "./pages/client_pages/solar/SolarQuote";
import SolarContact from "./pages/client_pages/solar/SolarContact";
import SolarSavingsBatteryRebates from "./pages/client_pages/solar/SolarSavingsBatteryRebates";
import SolarSavingsNoQualify from "./pages/client_pages/solar/SolarSavingsNoQualify";
import SolarHouseholdIQ from "./pages/client_pages/solar/SolarHouseholdIQ";
import SolarSavingsEndingSoon from "./pages/client_pages/solar/SolarSavingsEndingSoon";
import SolarCSER from "./pages/client_pages/solar/SolarCSER";
import SolarGiveawayJune from "./pages/client_pages/solar/SolarGiveawayJune";

// Finance Division Pages (27 pages)
import FinanceHome from "./pages/client_pages/finance/FinanceHome";
import FinanceServicesFirstHome from "./pages/client_pages/finance/FinanceServicesFirstHome";
import FinanceServicesInvestment from "./pages/client_pages/finance/FinanceServicesInvestment";
import FinanceServicesMortgage from "./pages/client_pages/finance/FinanceServicesMortgage";
import FinanceServicesRefinancing from "./pages/client_pages/finance/FinanceServicesRefinancing";
import FinanceServicesAssets from "./pages/client_pages/finance/FinanceServicesAssets";
import FinanceServicesPersonal from "./pages/client_pages/finance/FinanceServicesPersonal";
import FinanceServicesRefinance from "./pages/client_pages/finance/FinanceServicesRefinance";
import FinanceServicesConstruction from "./pages/client_pages/finance/FinanceServicesConstruction";
import FinanceServicesCommercial from "./pages/client_pages/finance/FinanceServicesCommercial";
import FinanceServicesCustomerFinance from "./pages/client_pages/finance/FinanceServicesCustomerFinance";
import FinanceServicesSMSF from "./pages/client_pages/finance/FinanceServicesSMSF";
import FinanceServicesPersonalAsset from "./pages/client_pages/finance/FinanceServicesPersonalAsset";
import FinanceServicesPersonalLoans from "./pages/client_pages/finance/FinanceServicesPersonalLoans";
import FinanceServicesPersonalLoansV2 from "./pages/client_pages/finance/FinanceServicesPersonalLoansV2";
import FinanceServicesBadCredit from "./pages/client_pages/finance/FinanceServicesBadCredit";
import FinanceServicesSolarLoans from "./pages/client_pages/finance/FinanceServicesSolarLoans";
import FinanceServicesPropertySolarFinance from "./pages/client_pages/finance/FinanceServicesPropertySolarFinance";
import FinanceWealthStrategy from "./pages/client_pages/finance/FinanceWealthStrategy";
import FinanceWealthSMSF from "./pages/client_pages/finance/FinanceWealthSMSF";
import FinanceWealthPlanning from "./pages/client_pages/finance/FinanceWealthPlanning";
import FinancePersonalAsset from "./pages/client_pages/finance/FinancePersonalAsset";
import FinanceResources from "./pages/client_pages/finance/FinanceResources";
import FinanceFAQ from "./pages/client_pages/finance/FinanceFAQ";
import FinanceToolsBorrowingPower from "./pages/client_pages/finance/FinanceToolsBorrowingPower";
import FinanceToolsRefinance from "./pages/client_pages/finance/FinanceToolsRefinance";
import FinanceToolsSMSF from "./pages/client_pages/finance/FinanceToolsSMSF";
import FinanceToolsStampDuty from "./pages/client_pages/finance/FinanceToolsStampDuty";
import FinanceToolsComparison from "./pages/client_pages/finance/FinanceToolsComparison";
import FinanceToolsPersonalAsset from "./pages/client_pages/finance/FinanceToolsPersonalAsset";
import FinanceApply from "./pages/client_pages/finance/FinanceApply";
import FinanceContact from "./pages/client_pages/finance/FinanceContact";

// Property Division Pages (18 pages)
import PropertyHome from "./pages/client_pages/property/PropertyHome";
import PropertyStrategyDataDriven from "./pages/client_pages/property/PropertyStrategyDataDriven";
import PropertyStrategyGoals from "./pages/client_pages/property/PropertyStrategyGoals";
import PropertyStrategyDiversification from "./pages/client_pages/property/PropertyStrategyDiversification";
import PropertyStrategySolarValueAdd from "./pages/client_pages/property/PropertyStrategySolarValueAdd";
import PropertyStrategyFinanceOptimization from "./pages/client_pages/property/PropertyStrategyFinanceOptimization";
import PropertyServicesInvestmentStrategy from "./pages/client_pages/property/PropertyServicesInvestmentStrategy";
import PropertyServicesOPAPlus from "./pages/client_pages/property/PropertyServicesOPAPlus";
import PropertyServicesTaxProtection from "./pages/client_pages/property/PropertyServicesTaxProtection";
import PropertyServicesPropertySolarPackage from "./pages/client_pages/property/PropertyServicesPropertySolarPackage";
import PropertyServicesInvestmentFinancing from "./pages/client_pages/property/PropertyServicesInvestmentFinancing";
import PropertyResources from "./pages/client_pages/property/PropertyResources";
import PropertyFAQ from "./pages/client_pages/property/PropertyFAQ";
import PropertyToolsInvestmentCalculator from "./pages/client_pages/property/PropertyToolsInvestmentCalculator";
import EOIForm from "./pages/client_pages/property/EOIForm";
import AandLForm from "./pages/client_pages/property/AandLForm";
import PropertyTransactionForm from "./pages/client_pages/property/PropertyTransactionForm";
import PropertyToolsRentalYield from "./pages/client_pages/property/PropertyToolsRentalYield";
import PropertyToolsPortfolioGrowth from "./pages/client_pages/property/PropertyToolsPortfolioGrowth";
import PropertyToolsPropertySolarValue from "./pages/client_pages/property/PropertyToolsPropertySolarValue";
import PropertyConsultation from "./pages/client_pages/property/PropertyConsultation";
import PropertyContact from "./pages/client_pages/property/PropertyContact";
import PropertyCaseStudies from "./pages/client_pages/property/PropertyCaseStudies";
import PropertyWebinarMortgageTaxRetirement from "./pages/client_pages/property/PropertyWebinarMortgageTaxRetirement";
import PropertyTeam from "./pages/client_pages/property/PropertyTeam";
import PropertyStrategists from "./pages/client_pages/property/PropertyStrategists";
import PortalPhase2Finance from "./pages/client_pages/property/build-portal/PortalPhase2Finance";
import PortalPhase3Construction from "./pages/client_pages/property/build-portal/PortalPhase3Construction";
import PropertyManagement from "./pages/client_pages/property/management/PropertyManagement";
import PropertyManagementLocation from "./pages/client_pages/property/management/PropertyManagementLocation";

// Water Division Pages (14 pages)
import WaterHome from "./pages/client_pages/water/WaterHome";
import WaterFiltersHub from "./pages/client_pages/water/WaterFiltersHub";
import WaterFiltrationHub from "./pages/client_pages/water/WaterFiltrationHub";
import WaterPurifiersHub from "./pages/client_pages/water/WaterPurifiersHub";
import WaterFiltersUnderSink from "./pages/client_pages/water/WaterFiltersUnderSink";
import WaterPurifiersUnderSink from "./pages/client_pages/water/WaterPurifiersUnderSink";
import WaterFiltrationUV from "./pages/client_pages/water/WaterFiltrationUV";
import WaterBlogHardWater from "./pages/client_pages/water/WaterBlogHardWater";
import WaterBlogSeqwater from "./pages/client_pages/water/WaterBlogSeqwater";
import WaterBlogChlorine from "./pages/client_pages/water/WaterBlogChlorine";
import WaterBlogReverseOsmosis from "./pages/client_pages/water/WaterBlogReverseOsmosis";
import WaterBlogTapWaterSafe from "./pages/client_pages/water/WaterBlogTapWaterSafe";
import WaterBlogROvsWholeHome from "./pages/client_pages/water/WaterBlogROvsWholeHome";
import WaterLocationGoldCoast from "./pages/client_pages/water/WaterLocationGoldCoast";

// Legal Pages (5 pages)
import PrivacyPolicy from "./pages/client_pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/client_pages/legal/TermsOfService";
import FinancialServicesGuide from "./pages/client_pages/legal/FinancialServicesGuide";
import Disclaimer from "./pages/client_pages/legal/Disclaimer";
import Complaints from "./pages/client_pages/legal/Complaints";

// Calculator Pages (13 pages)
import SolarSavingsCalculator from "./pages/client_pages/calculators/SolarSavingsCalculator";
import SolarBatteryROICalculator from "./pages/client_pages/calculators/SolarBatteryROICalculator";
import RefinanceSavingsCalculator from "./pages/client_pages/calculators/RefinanceSavingsCalculator";
import BorrowingPowerCalculator from "./pages/client_pages/calculators/BorrowingPowerCalculator";
import LoanComparisonCalculator from "./pages/client_pages/calculators/LoanComparisonCalculator";
import PersonalAssetFinanceCalculator from "./pages/client_pages/calculators/PersonalAssetFinanceCalculator";
import SMSFPropertyCalculator from "./pages/client_pages/calculators/SMSFPropertyCalculator";
import StampDutyCalculator from "./pages/client_pages/calculators/StampDutyCalculator";
import PropertyInvestmentROICalculator from "./pages/client_pages/calculators/PropertyInvestmentROICalculator";
import RentalYieldCalculator from "./pages/client_pages/calculators/RentalYieldCalculator";
import PortfolioGrowthProjector from "./pages/client_pages/calculators/PortfolioGrowthProjector";
import PropertySolarROICalculator from "./pages/client_pages/calculators/PropertySolarROICalculator";
import TaxOptimizationCalculator from "./pages/client_pages/calculators/TaxOptimizationCalculator";
import { brandConfig } from "./brandConfig";
import theme from "./theme";

// Module configurations
import clientsModuleConfig from "./pages/clients/moduleConfig";
import passwordsModuleConfig from "./pages/passwords/moduleConfig";
import employeesModuleConfig from "./pages/employees/moduleConfig";
import companiesModuleConfig from "./pages/companies/moduleConfig";
import CompaniesList from "./pages/companies/CompaniesList";
import NewCompany from "./pages/companies/NewCompany";
import CompanyDetails from "./pages/companies/CompanyDetails";
import EditCompany from "./pages/companies/EditCompany";
import opportunitiesModuleConfig from "./pages/opportunities/moduleConfig";
import companyKnowledgeModuleConfig from "./pages/companyknowledge/moduleConfig";

/*
 * MIGRATION NOTE: We are transitioning to a dynamic module routing system.
 *
 * The Clients module has been converted as the example pattern.
 * As we update each module, we will:
 * 1. Create/update its moduleConfig.ts file (see clients/moduleConfig.ts as example)
 * 2. Import the moduleConfig here
 * 3. Add it to the modules array below
 * 4. Remove its hardcoded routes from below
 *
 * This allows modules to be truly plug-and-play with automatic route registration
 * and centralized permission management.
 *
 * TO CONVERT: Projects, Bills, Products, Sessions, Emails, etc.
 */

// Import other module configs here as you convert them:
import seoMetadataModuleConfig from "./pages/seometadata/moduleConfig";
import calculatorModuleConfig from "./pages/calculator/moduleConfig";
import commandModuleConfig from "./pages/command/moduleConfig";
import financeModuleConfig from "./pages/finance/moduleConfig";
import buildPortalModuleConfig from "./pages/build-portal/moduleConfig";
import adminModuleConfig from "./pages/admin/moduleConfig";
import analyticsModuleConfig from "./pages/analytics/moduleConfig";
import mediaCDNModuleConfig from "./pages/media-cdn/moduleConfig";
import notificationsModuleConfig from "./pages/notifications/moduleConfig";
import commsLogModuleConfig from "./pages/comms-log/moduleConfig";
import smsModuleConfig from "./pages/sms/moduleConfig";
import emailsModuleConfig from "./pages/emails/moduleConfig";
import tomModuleConfig from "./pages/tom/moduleConfig";
import { TomProvider } from "./pages/tom/TomProvider";
// import productsModuleConfig from "./pages/products/moduleConfig";

// Module configs for hardcoded-routed modules wrapped in ModulePageLayout below
// (these still use hardcoded <Route> elements, NOT the dynamic modules array)
import subscriptionModuleConfig from "./pages/subscriptions/moduleConfig";

// Combine all module configurations
const modules = [
  clientsModuleConfig,
  passwordsModuleConfig,
  employeesModuleConfig,
  companiesModuleConfig,
  opportunitiesModuleConfig,
  seoMetadataModuleConfig, // SEO Manager with ADMIN permissions
  calculatorModuleConfig, // Calculator Leads - view/manage calculator submissions
  commandModuleConfig, // Command Centre - GHL/Pipedrive/Xero cockpit + commissions tracker
  financeModuleConfig, // Finance — One Finance's loan book: statements → loans → deals (FINANCE_VIEW / _EDIT / _ADMIN, 27 Oct 2026)
  buildPortalModuleConfig, // Build portal (demo, 8 Oct 2026) — the client's view of their house build
  companyKnowledgeModuleConfig, // Company knowledge base with COMPANY_KNOWLEDGE_* permissions
  adminModuleConfig, // System administration with ADMIN/TENANT_MASTER_ADMIN permissions
  analyticsModuleConfig, // Privacy-first website analytics
  mediaCDNModuleConfig, // Media CDN for file hosting with IPFS storage
  notificationsModuleConfig, // Notifications — navbar bell, personal inbox (self), ADMIN log (view)
  smsModuleConfig, // SMS — inbox, send, inbound notifications on One Group's own number + key (2026-10-16, ported from master)
  commsLogModuleConfig, // Comms Log — provider-truth outgoing SMS + email log (COMMS_LOG_VIEW / COMMS_LOG_ADMIN)
  emailsModuleConfig, // Emails — inbox, drafts, send as dealmanager@ (2026-10-05, ported from master)
  tomModuleConfig, // Tom — required by the emails module's AI trainer (useTom); panel not mounted
  // Add other modules here as you convert them:
  // productsModuleConfig,
];

// Protected Route Component
import { ProtectedRoute } from "./components/ProtectedRoute";
import { SecurityPage } from "./pages/authentication";
import LoginPage from "./pages/authentication/LoginPage";
import OnboardingPage from "./pages/onboarding/OnboardingPage";
import { ModulePageLayout } from "./components/ModulePageLayout";

// Loading component for lazy-loaded routes
const LoadingFallback = () => (
  <Center h="100vh">
    <Spinner size="xl" color={brandConfig.colors.primary} />
  </Center>
);

// Bill-related imports (moved to dynamic routing via billsModuleConfig)
// Special bill pages that aren't in the module
import BillChaserPage from "./pages/admin/billChaserPage";



// Legacy products module retired — superseded by p2 (removed from master-frontend;
// backend schema dropped the Product/ProductVariant types). Routes removed below.

// Email-related imports - Now handled by emailsModuleConfig

// Knowledge Base imports
// import { KnowledgeBaseList, ArticleViewer } from "./pages/knowledgebase";

// Subscription/Billing-related imports
import SubscriptionsDashboard from "./pages/subscriptions/SubscriptionsDashboard";
import ManageSubscriptions from "./pages/subscriptions/ManageSubscriptions";
import PaymentMethods from "./pages/subscriptions/PaymentMethods";
import InvoiceHistory from "./pages/subscriptions/InvoiceHistory";
import BillingSettings from "./pages/subscriptions/BillingSettings";
import CreateSubscription from "./pages/subscriptions/CreateSubscription";
import ManualCharging from "./pages/subscriptions/ManualCharging";
import EditSubscription from "./pages/subscriptions/EditSubscription";

// Admin and dashboard imports
import AdminDashboard from "./pages/AdminDashboard";
import BrandStyleGuide from "./pages/admin/BrandStyleGuide";

// (test/development pages removed)



// Contexts and Layout
import { AuthProvider } from "./contexts/AuthContext";
import { ModulePermissionsProvider, useModulePermissions } from "./contexts/ModulePermissionsContext";
import { IpfsGatewayLoader } from "./components/IpfsGatewayLoader";

// Profile-related imports
import ViewProfile from "./pages/profile/ViewProfile";
import EditProfile from "./pages/profile/EditProfile";
import Settings from "./pages/profile/Settings";
import ShippingAddresses from "./pages/profile/ShippingAddresses";
import ProfilePaymentMethods from "./pages/profile/PaymentMethods";
import SubscriptionOffers from "./pages/profile/SubscriptionOffers";
import CurrentSubscriptions from "./pages/profile/CurrentSubscriptions";

// import ShippingAddresses from "./pages/profile/ShippingAddresses";

// Permissions Matrix import
import Permissions from "./pages/Permissions";
// import PaymentMethods from "./pages/profile/PaymentMethods";

// Floating navbar component
import { FloatingNavbar } from "./components/FloatingNavbar";
import { useAuth } from "./contexts/AuthContext";

// Analytics tracker - tracks page views and engagement
import { AnalyticsTracker } from "./pages/analytics/components/AnalyticsTracker";
import BrandStyleGuideV2 from "./pages/admin/BrandStyleGuideV2";
import BrandStyleGuideV3 from "./pages/admin/BrandStyleGuideV3";

const AppContent = () => {
  const { isAuthenticated } = useAuth();
  const { permissions: backendPerms, loading: backendPermsLoading } = useModulePermissions();

  // Resolve permissionLevel → actual permission strings from backend
  // Modules using the new pattern have permissionLevel on routes/nav and empty permission arrays.
  // Modules not yet migrated still have hardcoded permission arrays — those pass through unchanged.
  const resolvedModules = React.useMemo(() => {
    return modules.map(module => {
      const modulePerms = backendPerms[module.id];
      if (!modulePerms) return module; // Not migrated yet — use hardcoded permissions

      return {
        ...module,
        routes: module.routes?.map((route: any) => {
          const level = (route as any).permissionLevel;
          if (!level) return route;
          return { ...route, permissions: (modulePerms as any)[level] || [] };
        }),
        navigation: module.navigation?.map((navItem: any) => {
          const level = (navItem as any).permissionLevel;
          if (!level) return navItem;
          return { ...navItem, permissions: (modulePerms as any)[level] || [] };
        }),
        permissions: {
          ...module.permissions,
          view: modulePerms.view || module.permissions?.view,
          create: modulePerms.create || module.permissions?.create,
          edit: modulePerms.edit || module.permissions?.edit,
          delete: modulePerms.delete || module.permissions?.delete,
          ...(modulePerms.publish ? { publish: modulePerms.publish } : {}),
          ...(modulePerms.send ? { send: modulePerms.send } : {}),
          ...(modulePerms.admin ? { admin: modulePerms.admin } : {}),
          ...(modulePerms.addressBook ? { addressBook: modulePerms.addressBook } : {}),
          ...(modulePerms.share ? { share: modulePerms.share } : {}),
          ...(modulePerms.permissions ? { permissions: modulePerms.permissions } : {}),
          ...(modulePerms.merge ? { merge: modulePerms.merge } : {}),
          ...(modulePerms.self ? { self: modulePerms.self } : {}),
        },
      };
    });
  }, [backendPerms]);

  return (
    <>
      {/* Scroll to top on every route change */}
      <ScrollToTop />

      {/* Analytics tracking - runs on every page view */}
      <AnalyticsTracker enabled={true} />

      {/* Show floating navbar only when authenticated */}
      {isAuthenticated && <FloatingNavbar />}


      {/* Each page now includes its own NavbarWithCallToAction and FooterWithFourColumns for consistency */}
      <Routes>
        {/* ============ ONE GROUP CLIENT PAGES ============ */}
        {/* Public website pages for onegroupaustralasia.com.au */}

        {/* Main Site Pages */}
        <Route path="/" element={<OneGroupHome />} />
        {/* Sign-in page — also the landing for a session refused with ACCESS_BLOCKED (/login?blocked=1). */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/email-link" element={<EmailLinkCallback />} />
        <Route path="/auth/sms-link" element={<SmsLinkCallback />} />
        <Route path="/v2" element={<OneGroupHome />} />
        <Route path="/about" element={<About />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/solutions/solar-property" element={<SolutionsSolarProperty />} />
        <Route path="/solutions/finance-solar" element={<SolutionsFinanceSolar />} />
        <Route path="/solutions/wealth-building" element={<SolutionsWealthBuilding />} />
        <Route path="/solutions/first-home-solar" element={<SolutionsFirstHomeSolar />} />
        <Route path="/solutions/investment-solar-battery-upgrade" element={<SolutionsInvestmentSolarBattery />} />
        <Route path="/solutions/refinance-solar-battery" element={<SolutionsRefinanceSolarBattery />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/success-stories" element={<SuccessStories />} />

        {/* Solar Division Pages */}
        <Route path="/solar" element={<SolarHome />} />
        <Route path="/solar/services" element={<SolarServices />} />
        <Route path="/solar/services/residential" element={<SolarServicesResidential />} />
        <Route path="/solar/services/commercial" element={<SolarServicesCommercial />} />
        <Route path="/solar/services/battery" element={<SolarServicesBattery />} />
        <Route path="/solar/services/monitoring" element={<SolarServicesMonitoring />} />
        <Route path="/solar/services/investment-property" element={<SolarServicesInvestmentProperty />} />
        <Route path="/solar/process" element={<SolarProcess />} />
        <Route path="/solar/resources" element={<SolarResources />} />
        <Route path="/solar/resources/technology" element={<SolarResourcesTechnology />} />
        <Route path="/solar/resources/incentives" element={<SolarResourcesIncentives />} />
        <Route path="/solar/resources/maintenance" element={<SolarResourcesMaintenance />} />
        <Route path="/solar/resources/comparisons" element={<SolarResourcesComparisons />} />
        <Route path="/solar/resources/battery-guide" element={<SolarResourcesBatteryGuide />} />
        <Route path="/solar/faq" element={<SolarFAQ />} />
        <Route path="/solar/calculator" element={<SolarCalculator />} />
        <Route path="/solar/quote" element={<SolarQuote />} />
        <Route path="/solar/contact" element={<SolarContact />} />
        <Route path="/solar/battery-rebates" element={<SolarSavingsBatteryRebates />} />
        <Route path="/solar/battery-rebates/no-qualify" element={<SolarSavingsNoQualify />} />
        <Route path="/solar/household-iq" element={<SolarHouseholdIQ />} />
        <Route path="/solar/solar-savings-ending-soon" element={<SolarSavingsEndingSoon />} />
        <Route path="/solar/cser" element={<SolarCSER />} />
        <Route path="/solar/giveaway-june" element={<SolarGiveawayJune />} />

        {/* Finance Division Pages */}
        <Route path="/finance" element={<FinanceHome />} />
        <Route path="/finance/services/first-home" element={<FinanceServicesFirstHome />} />
        <Route path="/finance/services/mortgage" element={<FinanceServicesMortgage />} />
        <Route path="/finance/services/investment" element={<FinanceServicesInvestment />} />
        <Route path="/finance/services/refinancing" element={<FinanceServicesRefinancing />} />
        <Route path="/finance/services/refinance" element={<FinanceServicesRefinance />} />
        <Route path="/finance/services/assets" element={<FinanceServicesAssets />} />
        <Route path="/finance/services/personal" element={<FinanceServicesPersonal />} />
        <Route path="/finance/services/construction" element={<FinanceServicesConstruction />} />
        <Route path="/finance/services/commercial" element={<FinanceServicesCommercial />} />
        <Route path="/finance/services/customer-finance" element={<FinanceServicesCustomerFinance />} />
        <Route path="/finance/services/smsf" element={<FinanceServicesSMSF />} />
        <Route path="/finance/services/personal-asset" element={<FinanceServicesPersonalAsset />} />
        <Route path="/finance/services/personal-loans" element={<FinanceServicesPersonalLoans />} />
        <Route path="/finance/services/personal-loans-v2" element={<FinanceServicesPersonalLoansV2 />} />
        <Route path="/finance/services/bad-credit" element={<FinanceServicesBadCredit />} />
        <Route path="/finance/services/solar-loans" element={<FinanceServicesSolarLoans />} />
        <Route path="/finance/services/property-solar-finance" element={<FinanceServicesPropertySolarFinance />} />
        <Route path="/finance/wealth/strategy" element={<FinanceWealthStrategy />} />
        <Route path="/finance/wealth/smsf" element={<FinanceWealthSMSF />} />
        <Route path="/finance/wealth/planning" element={<FinanceWealthPlanning />} />
        <Route path="/finance/personal-asset" element={<FinancePersonalAsset />} />
        <Route path="/finance/resources" element={<FinanceResources />} />
        <Route path="/finance/faq" element={<FinanceFAQ />} />
        <Route path="/finance/tools/borrowing-power" element={<FinanceToolsBorrowingPower />} />
        <Route path="/finance/tools/refinance" element={<FinanceToolsRefinance />} />
        <Route path="/finance/tools/smsf" element={<FinanceToolsSMSF />} />
        <Route path="/finance/tools/stamp-duty" element={<FinanceToolsStampDuty />} />
        <Route path="/finance/tools/comparison" element={<FinanceToolsComparison />} />
        <Route path="/finance/tools/personal-asset" element={<FinanceToolsPersonalAsset />} />
        <Route path="/finance/apply" element={<FinanceApply />} />
        <Route path="/finance/contact" element={<FinanceContact />} />

        {/* Property Division Pages */}
        <Route path="/property" element={<PropertyHome />} />
        <Route path="/property/strategy/data-driven" element={<PropertyStrategyDataDriven />} />
        <Route path="/property/strategy/goals" element={<PropertyStrategyGoals />} />
        <Route path="/property/strategy/diversification" element={<PropertyStrategyDiversification />} />
        <Route path="/property/strategy/solar-value-add" element={<PropertyStrategySolarValueAdd />} />
        <Route path="/property/strategy/finance-optimization" element={<PropertyStrategyFinanceOptimization />} />
        <Route path="/property/services/investment-strategy" element={<PropertyServicesInvestmentStrategy />} />
        <Route path="/property/services/opa-plus" element={<PropertyServicesOPAPlus />} />
        <Route path="/property/services/tax-protection" element={<PropertyServicesTaxProtection />} />
        <Route path="/property/services/property-solar-package" element={<PropertyServicesPropertySolarPackage />} />
        <Route path="/property/services/investment-financing" element={<PropertyServicesInvestmentFinancing />} />
        <Route path="/property/resources" element={<PropertyResources />} />
        <Route path="/property/resources/webinar-mortgage-tax-retirement" element={<PropertyWebinarMortgageTaxRetirement />} />
        <Route path="/property/resources/eoi-form" element={<EOIForm />} />
        <Route path="/property/resources/opa-form" element={<AandLForm />} />
        <Route path="/property/resources/transaction-form" element={<PropertyTransactionForm />} />
        <Route path="/property/faq" element={<PropertyFAQ />} />
        <Route path="/property/tools/investment-calculator" element={<PropertyToolsInvestmentCalculator />} />
        <Route path="/property/tools/rental-yield" element={<PropertyToolsRentalYield />} />
        <Route path="/property/tools/portfolio-growth" element={<PropertyToolsPortfolioGrowth />} />
        <Route path="/property/tools/property-solar-value" element={<PropertyToolsPropertySolarValue />} />
        <Route path="/property/consultation" element={<PropertyConsultation />} />
        <Route path="/property/contact" element={<PropertyContact />} />
        <Route path="/property/case-studies" element={<PropertyCaseStudies />} />
        <Route path="/property/team" element={<PropertyTeam />} />
        <Route path="/property/strategists" element={<PropertyStrategists />} />
        {/* Build Portal — Client views for Phase 2 (Finance) and Phase 3 (Construction) */}
        <Route path="/property/portal/phase2" element={<PortalPhase2Finance />} />
        <Route path="/property/portal/phase3" element={<PortalPhase3Construction />} />
        {/* Property Management — Queensland city pages */}
        <Route path="/property/management" element={<PropertyManagement />} />
        <Route path="/property/management/:city" element={<PropertyManagementLocation />} />

        {/* Water Division Pages — One Water Australia */}
        <Route path="/water" element={<WaterHome />} />
        <Route path="/water/water-filters" element={<WaterFiltersHub />} />
        <Route path="/water/water-filtration" element={<WaterFiltrationHub />} />
        <Route path="/water/water-purifiers" element={<WaterPurifiersHub />} />
        <Route path="/water/water-filters/under-sink-system" element={<WaterFiltersUnderSink />} />
        <Route path="/water/water-purifiers/under-sink-system" element={<WaterPurifiersUnderSink />} />
        <Route path="/water/water-filtration/uv-system" element={<WaterFiltrationUV />} />
        <Route path="/water/blog/hard-water-australia" element={<WaterBlogHardWater />} />
        <Route path="/water/blog/seqwater-annual-report-2026" element={<WaterBlogSeqwater />} />
        <Route path="/water/blog/chlorine-in-tap-water" element={<WaterBlogChlorine />} />
        <Route path="/water/blog/reverse-osmosis-guide" element={<WaterBlogReverseOsmosis />} />
        <Route path="/water/blog/tap-water-safe-australia" element={<WaterBlogTapWaterSafe />} />
        <Route path="/water/blog/reverse-osmosis-vs-whole-home" element={<WaterBlogROvsWholeHome />} />
        <Route path="/water/water-quality/gold-coast" element={<WaterLocationGoldCoast />} />

        {/* Brand Style Guide Pages (Public Access) */}
        <Route path="/brand-guide" element={<BrandStyleGuide />} />
        <Route path="/brand-guide-v2" element={<BrandStyleGuideV2 />} />
        <Route path="/brand-guide-v3" element={<BrandStyleGuideV3 />} />

        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/financial-services-guide" element={<FinancialServicesGuide />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/complaints" element={<Complaints />} />

        {/* Calculator Pages */}
        <Route path="/calculators/solar-savings" element={<SolarSavingsCalculator />} />
        <Route path="/calculators/solar-battery-roi" element={<SolarBatteryROICalculator />} />
        <Route path="/calculators/refinance-savings" element={<RefinanceSavingsCalculator />} />
        <Route path="/calculators/borrowing-power" element={<BorrowingPowerCalculator />} />
        <Route path="/calculators/loan-comparison" element={<LoanComparisonCalculator />} />
        <Route path="/calculators/personal-asset-finance" element={<PersonalAssetFinanceCalculator />} />
        <Route path="/calculators/smsf-property" element={<SMSFPropertyCalculator />} />
        <Route path="/calculators/stamp-duty" element={<StampDutyCalculator />} />
        <Route path="/calculators/property-investment-roi" element={<PropertyInvestmentROICalculator />} />
        <Route path="/calculators/rental-yield" element={<RentalYieldCalculator />} />
        <Route path="/calculators/portfolio-growth" element={<PortfolioGrowthProjector />} />
        <Route path="/calculators/property-solar-roi" element={<PropertySolarROICalculator />} />
        <Route path="/calculators/tax-optimization" element={<TaxOptimizationCalculator />} />

        {/* ============ BACKEND MODULES ============ */}
        {/* Management system routes (protected) */}


        {/* Site Map page (admin utility) */}
        <Route path="/site-map" element={<SiteMap />} />

        {/* Dynamic Module Routes (permissions resolved from backend) */}
        {resolvedModules.map((module) =>
          module.routes?.map((route: any) => {
            const pageComponent = (
              <Suspense fallback={<LoadingFallback />}>
                <route.component />
              </Suspense>
            );
            // Routes opting into useLayout get the shared ModulePageLayout
            // (Navbar + Breadcrumb + Container + Footer). Others render bare.
            const content = route.useLayout ? (
              <ModulePageLayout moduleConfig={module} {...(route.layoutOptions || {})}>
                {pageComponent}
              </ModulePageLayout>
            ) : (
              pageComponent
            );
            // Seamless-auth: protect when the route declares a permissionLevel
            // (resolved at runtime) OR explicit permissions. See seamless-page-auth-pattern.md.
            const hasPermissionLevel = !!route.permissionLevel;
            const hasExplicitPermissions = route.permissions && route.permissions.length > 0;
            const isProtected = hasPermissionLevel || hasExplicitPermissions;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  isProtected ? (
                    // `permissionsPending`: a permissionLevel route resolves to NO permissions until the
                    // backend manifest arrives — without this, any signed-in person saw an owner-only
                    // page (e.g. /command/settings) for that moment. Wait instead (2026-09-28).
                    <ProtectedRoute requiredPermissions={route.permissions || []} permissionsPending={!!route.permissionLevel && backendPermsLoading}>
                      {content}
                    </ProtectedRoute>
                  ) : (
                    content
                  )
                }
              />
            );
          })
        )}

        {/* Security & sign-in (all authed) + Onboarding (ONBOARDING permission) */}
        <Route path="/security" element={<ProtectedRoute requiredPermissions={[]}><SecurityPage /></ProtectedRoute>} />
        <Route path="/onboarding" element={<ProtectedRoute requiredPermissions={["ONBOARDING"]}><OnboardingPage /></ProtectedRoute>} />

        {/* Website routes */}

        {/* Bills module removed — bill routes retired */}
        {/* Special bill routes not in the module */}
        <Route path="/bill-chaser" element={<BillChaserPage />} />

        {/* Product routes retired — legacy products module superseded by p2 */}

        {/* Company routes */}
        <Route path="/companies" element={<CompaniesList />} />
        <Route path="/companies/new" element={<NewCompany />} />
        <Route path="/companies/:id" element={<CompanyDetails />} />
        <Route path="/companies/edit/:id" element={<EditCompany />} />

        {/* Email routes - Now handled by dynamic routing via emailsModuleConfig */}

        {/* Knowledge Base routes - Admin only */}
        {/* <Route path="/knowledgebase" element={<KnowledgeBaseList />} /> */}
        {/* <Route path="/knowledgebase/:slug" element={<ArticleViewer />} /> */}

        {/* Permissions Matrix */}
        <Route path="/permissions" element={<Permissions />} />

        {/* Subscription/Billing routes */}
        <Route path="/subscriptions" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><SubscriptionsDashboard /></ModulePageLayout>} />                    {/* ADMIN: Overview dashboard of all client subscriptions, revenue stats */}
        <Route path="/subscriptions/manage" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><ManageSubscriptions /></ModulePageLayout>} />                {/* ADMIN: Manage existing subscriptions (cancel, modify, view details) */}
        <Route path="/subscriptions/create" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><CreateSubscription /></ModulePageLayout>} />                 {/* ADMIN: Create new recurring subscriptions for clients */}
        <Route path="/subscriptions/payment-methods" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><PaymentMethods /></ModulePageLayout>} />            {/* ADMIN: Add/remove client credit cards for future billing */}
        <Route path="/subscriptions/invoices" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><InvoiceHistory /></ModulePageLayout>} />                   {/* ADMIN/CLIENT: View invoice history and payment receipts */}
        <Route path="/subscriptions/settings" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><BillingSettings /></ModulePageLayout>} />                  {/* ADMIN: Configure billing settings, tax rates, company info */}
        <Route path="/subscriptions/manual-charging" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><ManualCharging /></ModulePageLayout>} />            {/* ADMIN: One-time charges using saved payment methods */}
        <Route path="/subscriptions/:id/edit" element={<ModulePageLayout moduleConfig={subscriptionModuleConfig}><EditSubscription /></ModulePageLayout>} />                 {/* ADMIN: Edit existing subscription details */}

        {/* Admin routes */}
        <Route path="/admin" element={<AdminDashboard />} />
        {/* BrandStyleGuideV2 now handled by adminModuleConfig */}


        {/* SEO Metadata routes now handled by dynamic module routing via seoMetadataModuleConfig */}

        {/* Profile routes */}
        <Route path="/profile" element={<ViewProfile />} />                        {/* USER: View profile details */}
        <Route path="/profile/edit" element={<EditProfile />} />                  {/* USER: Edit profile information */}
        <Route path="/profile/settings" element={<Settings />} />                  {/* USER: Manage profile settings */}
        <Route path="/profile/shipping" element={<ShippingAddresses />} />         {/* USER: Manage shipping addresses */}
        <Route path="/profile/payment-methods" element={<ProfilePaymentMethods />} />     {/* USER: Manage payment methods */}
        <Route path="/profile/subscription-offers" element={<SubscriptionOffers />} />     {/* USER: View subscription offers */}
        <Route path="/profile/subscriptions" element={<CurrentSubscriptions />} />     {/* USER: Manage current subscriptions */}


      </Routes>
    </>
  );
};

export const App = () => {
  // Check and set tenantId if missing
  React.useEffect(() => {
    const storedTenantId = localStorage.getItem('tenantId');
    if (!storedTenantId) {
      // Use the tenantId from brandConfig as default
      if (brandConfig.tenantId) {
        localStorage.setItem('tenantId', brandConfig.tenantId);
      }
    }
  }, []);

  return (
    <Router>
      <ApolloProvider client={apolloClient}>
        <IpfsGatewayLoader>
          <AuthProvider>
            <ModulePermissionsProvider>
              <ChakraProvider theme={theme}>
                {/* TomProvider: the emails module's AI trainer calls useTom (2026-10-05). */}
                <TomProvider>
                  <AuthProfilePrompt />
                  <AppContent />
                </TomProvider>
              </ChakraProvider>
            </ModulePermissionsProvider>
          </AuthProvider>
        </IpfsGatewayLoader>
      </ApolloProvider>
    </Router>
  );
};
